import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueFormat',
  standalone: true 
})
export class ValueFormatPipe implements PipeTransform {
  transform(value: any, field: string): string {
    if (value === null || value === undefined) return '-';

    if (field.toLowerCase().includes('date') && value instanceof Date) {
        return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(value);
    }

    if (typeof value === 'number' && ['predictedValue', 'actualValue', 'error', 'absoluteError', 'profit', 'pricePrediction', 'settlementPrice'].includes(field)) {
      return value.toFixed(2);
    }

    return value.toString();
  }
}
